export default __webpack_public_path__ + "static/media/default-avatar.1455435a.jpg";